<template>
  <!-- eslint-disable -->
<li class="catalog__item">
        <router-link class="catalog__pic" :to="{name: 'product', params: {id: product.id}}">
          <img :src="product.image"  :alt="product.title">
        </router-link>

        <h3 class="catalog__title">
          <a href="#">
            {{ product.title }}
          </a>
        </h3>

        <span class="catalog__price">
          {{ product.price | numberFormat}} р.
        </span>

        <ul class="colors colors--black">
          <li class="colors__item" v-for="elem in this.color" :key="elem.id">
            <label class="colors__label">
              <input class="colors__radio sr-only" type="radio" :value="elem.id">
              <span class="colors__value" :style="`background-color: ${elem.code}`">
              </span>
            </label>
          </li>
        </ul>
      </li>
</template>

<script>
import gotoPage from '@/helpers/gotoPages';
import numberFormat from '@/helpers/numberFormat';
import axios from 'axios';

export default {
  data() {
    return {
      color: null,
    };
  },
  props: ['product'],
  filters: {
    numberFormat,
  },
  methods: {
    gotoPage,
    loadColors() {
      axios.get('https://vue-study.skillbox.cc/api/colors')
      // eslint-disable-next-line
        .then(response => this.color = this.product.colors);
    },
  },
  created() {
    this.loadColors();
  },
};
</script>
